import styled from 'styled-components'
import { Flex } from 'components/common/styles'
import { WHITE, GREY_LIGHT } from 'constants/colors'

export const Placeholder = styled(Flex)`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: ${WHITE};
  background: ${GREY_LIGHT};
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid ${WHITE};
`
